import { createGlobalStyle } from 'styled-components'

import colors from '@settings/styleSettings'

import CircularStd from '@assets/fonts/CircularStd-Book.ttf'
import CircularStdMedium from '@assets/fonts/CircularStd-Medium.ttf'
import CircularStdBold from '@assets/fonts/CircularStd-Bold.ttf'
import InterRegular from '@assets/fonts/Inter-Regular.ttf'
import InterBold from '@assets/fonts/Inter-Bold.ttf'

const GlobalStyles = createGlobalStyle`
    @font-face {
      font-family: 'Inter-Regular';
      font-style: normal;
      font-weight: normal;
      src: url(${InterRegular}) format('truetype');
    }
    @font-face {
      font-family: 'Inter-Bold';
      font-style: normal;
      font-weight: normal;
      src: url(${InterBold}) format('truetype');
    }
    @font-face {
      font-family: 'Circular-Std';
      font-style: normal;
      font-weight: normal;
      src: url(${CircularStd}) format('truetype');
    }
    @font-face {
      font-family: 'Circular-Std-Bold';
      font-style: normal;
      font-weight: normal;
      src: url(${CircularStdBold}) format('truetype');
    }
    @font-face {
      font-family: 'Circular-Std-Medium';
      font-style: normal;
      font-weight: normal;
      src: url(${CircularStdMedium}) format('truetype');
    }
  /* @media print {
    header, footer, aside, form {
      display: none !important;
    }
  } */
  body {
    font-family: Circular-Std, sans-serif;
    height: 100%;
    width: 100%;
    margin: 0;
    background-color: ${colors.grayBackground};

  }
  ::-webkit-scrollbar {
    width: 14px;
  }
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background-color: rgba(155, 155, 155, 0.5);
    border-radius: 20px;
    border: transparent;
  }
  #root {
    height: 100%;
  }
  /* * {
  font-family: Rawline-Regular, sans-serif;
  } */
  html {
    color: ${colors.titleStrongBlack};
    height: 100%;
  }
  /* ._loading_overlay_content {
    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: -100px;
    margin-left: -100px;
  }
  ._loading_overlay_overlay {
    width:      100%;
    height:     100%;
    z-index:    10;
    top:        0;
    left:       0;
    position:   fixed;
  } */
`

export default GlobalStyles
